'use client';

import { Locales as LocaleType, Translate } from 'callabo-locale/src/hooks/useTranslate';
import { useParams } from 'next/navigation';
import { z } from 'zod';

export type Locales = LocaleType;

export function useTranslate(lang?: string): Translate<Locales> {
  let locale = useLocale();
  if (lang) {
    if (isMatch(koreanSchema, { locale: lang })) {
      locale = 'ko';
    } else if (isMatch(japaneseSchema, { locale: lang })) {
      locale = 'ja';
    } else if (isMatch(englishSchema, { locale: lang })) {
      locale = 'en';
    }
  }

  return new Translate(locale);
}

const koreanSchema = z.object({
  locale: z.literal('ko'),
});
const japaneseSchema = z.object({
  locale: z.literal('ja'),
});
const englishSchema = z.object({
  locale: z.literal('en'),
});

const isMatch = (schema: z.ZodObject, params: any) => {
  const parsed = schema.safeParse(params);
  return parsed.success;
};

export function useLocale(): Locales {
  const params = useParams();

  if (isMatch(koreanSchema, params)) {
    return 'ko';
  } else if (isMatch(japaneseSchema, params)) {
    return 'ja';
  } else if (isMatch(englishSchema, params)) {
    return 'en';
  }

  return 'ko';
}
